import React from 'react';
import appStore from '../assets/appstore.png';
import playStore from '../assets/playstore.png';
import Seo from '../components/Seo';

function MainContent() {
  return (
    <div className="content-container">
      <Seo
        title="Chartmaxx AI | AI Trading Chart Analysis for Forex, Crypto & Stocks"
        description="Upload any trading chart screenshot and get AI-powered technical analysis, market research, and simple insights for forex, crypto, stocks, commodities, and indices."
        path="/"
      />
      <h1 className="headline">
        Analysis for any
        trading chart. <br></br> Start chartmaxxing, trade like a pro</h1>
      <p className="paragraph">
        🚀 Ready to glow up your investing game? Say less!<br />
        Just drop in a chart of any stock, forex, or crypto—you’re good to go. 📈✨<br /><br />
        The app does the heavy lifting 🔥, breaking it down with simple, vibes-only insights 😎<br />
        so you know exactly what moves to make next. 💪💰
      </p>

      <div className='btn-container'>
        <a href="https://apps.apple.com/se/app/chartmaxx-ai/id6740340875" target="_blank" className="cta" rel="noreferrer">
          <img src={appStore} alt="Logo" className="logo" />
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.tommyjaks.chartmaxx&pcampaignid=web_share" target="_blank" className="cta" rel="noreferrer">
          <img src={playStore} alt="Logo" className="logo" />
        </a>
      </div>

    </div>
  );
}
export default MainContent;
